import React, { useEffect } from "react";
import { GridRow, GridColumn } from "emotion-flex-grid";
import { Icon } from "components/SvgIcons";
import BtnToolBar from "shared/BtnToolBar/index";
import Meta from "shared/Meta/index";
import { getRatingsMessage } from "helpers/getRatingsMessage";
import Rating from "shared/Rating";
import PreviewDisplay from "./Preview/index";
import { MainTitle } from "styles/General.styled.js";
import { HeadBlock, ToolBarWrap, BannerDisplay, RatingWrapDesktop, RatingText, PaidInCollectionBack } from "./styled";
import { CardWrapType1 } from "styles/MainCards.styled";

import Banner from "shared/Banner";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "styles/App.styled";
import { saveRecipeOrCollection, unSaveRecipeOrCollection } from "store/recipesReducer/recipesActions";
import { saveCollectionPage, saveRecipeCollectionPage } from "store/collectionReducer";

import { toggleModal, isUserLogin } from "store/loginReducer";

import dynamic from "next/dynamic";
const Reviews = dynamic(() => import("components/Reviews"), { ssr: false });
const Card = dynamic(() => import("./Card"), { ssr: false });
import { hideVideoModal, togglePaidInCollectionModal, togglePamentModal } from "store/modalReducer";
import { useIsMounted } from "helpers/hooks/useIsMounted";
import { useRouter } from "next/router";
import { getOwner } from "store/userReducer/userSelectors";

const btns = [
  { name: "Share", icon: "share2" },
  { name: "Like", icon: "saveslide" },
];

function CollectionDisplay({ collection }) {
  const isLogin = useSelector(isUserLogin);
  const dispatch = useDispatch();
  const router = useRouter();

  const handleClick = () => {
    if (!isLogin) dispatch(toggleModal(true));
    else if (collection.saved) {
      dispatch(
        unSaveRecipeOrCollection({
          type: "collections",
          id: collection.id,
          setSaved: saveCollectionPage,
        })
      );
    } else {
      dispatch(
        saveRecipeOrCollection({
          type: "collections",
          id: collection.id,
          setSaved: saveCollectionPage,
        })
      );
    }
  };

  if (!collection) return <Spinner />;

  const isMounted = useIsMounted();

  const isPrivateCollection = collection.paid;

  const paidInCollectionsJSON = typeof window !== "undefined" && sessionStorage.getItem("paidInCollections");
  let paidInCollectionsData;
  let paidInCollections;
  let buyCollection;
  if (paidInCollectionsJSON) {
    paidInCollectionsData = JSON.parse(paidInCollectionsJSON);
    paidInCollections = paidInCollectionsData.collections;
    buyCollection = paidInCollectionsData.buyCollection;
  }

  useEffect(() => {
    if (buyCollection) {
      dispatch(togglePamentModal(true));
    }
    return () => dispatch(hideVideoModal());
  }, [router.query.id]);

  const owner = useSelector(getOwner);
  const isOwner = owner.id === collection.collection_creator.id;
  const isFullAccess = isOwner || collection.purchased || !collection.paid;

  return (
    <>
      <HeadBlock>
        {isMounted && paidInCollections && (
          <PaidInCollectionBack onClick={() => dispatch(togglePaidInCollectionModal(true))}>
            <Icon icon="swipe_next" />
            Back to list
          </PaidInCollectionBack>
        )}

        <GridRow display={["block", "flex"]} justify="between" wrap="wrap">
          <GridColumn width={[12, "auto"]}>
            <MainTitle>{collection.title}</MainTitle>
            <Meta user={collection.collection_creator} />
          </GridColumn>
          <GridColumn width={[12, "auto"]} ml={["", "auto"]} className="hide-mobile-global">
            <ToolBarWrap>
              <RatingWrapDesktop hasReviews={collection.review_count}>
                <RatingText>{getRatingsMessage(collection.review_count)}</RatingText>
                <Rating value={collection.rating} />
              </RatingWrapDesktop>
              <BtnToolBar
                saved={collection.saved}
                onSave={handleClick}
                btns={btns}
                socialImgUrl={collection.main_image}
                mealPlanId={collection.id}
              />
            </ToolBarWrap>
          </GridColumn>
        </GridRow>
      </HeadBlock>
      <PreviewDisplay
        collection={collection}
        image={collection.main_image}
        description={collection.description}
        tags={collection.tags}
        isPaid={collection.paid}
        purchased={collection.purchased}
        id={collection.id}
        price={collection.price}
        paidInCollectionsData={paidInCollectionsData}
        isOwner={isOwner}
        isFullAccess={isFullAccess}
      />

      {isLogin ? (
        ""
      ) : (
        <BannerDisplay>
          <Banner description="Sign up for a FREE account to save these recipes" />
        </BannerDisplay>
      )}

      <CardWrapType1>
        <Card
          isPrivateCollection={isPrivateCollection}
          list={collection.recipe}
          icon="save"
          type="recipes"
          setSaved={saveRecipeCollectionPage}
        />
      </CardWrapType1>

      {!collection.id ? <Spinner /> : <Reviews type="collection" data={collection} canMakeReview={isFullAccess} />}
    </>
  );
}

export default CollectionDisplay;
